import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
} from "@angular/core";
import Chart from "chart.js";

@Component({
  selector: "ab-bar-chart",
  templateUrl: "./bar-chart.component.html",
})
export class BarChartComponent implements AfterViewInit, OnChanges {
  public chart: Chart;
  @Input() private config: any;
  private canvasEl: HTMLCanvasElement;
  private nativeEl: HTMLElement;

  constructor(element: ElementRef) {
    this.nativeEl = element.nativeElement;
  }

  public ngAfterViewInit() {
    this.canvasEl = this.nativeEl.querySelector("canvas");
    this.renderChart();
  }

  public ngOnChanges() {
    this.renderChart();
  }

  private renderChart() {
    if (this.config == null || this.canvasEl == null) {
      return;
    }

    if (this.chart == null) {
      this.chart = new Chart(this.canvasEl, {
        type: "bar",
        data: this.config.data,
        options: this.config.options || {},
      });
    } else {
      this.chart.data = this.config.data;
      this.chart.options = this.config.options || {};
      this.chart.update();
    }
  }
}
